<!-- 页面头部 -->
<template>
  <div class="model-content">
      <section @click="goBack"> 
          <i class="iconfont fanhui"></i>
          <span>返回</span>
      </section>
      <section style="font-size:0.95rem;">{{pageName}}</section>
      <section @click="goHome">
          <i class="iconfont shouye"></i>
          <span>首页</span>
      </section>
  </div>
</template>

<script >
export default {
  data() {
    return {

    }
  },
  props:["pageName"],
  methods: {
      goBack(){
          this.$router.go(-1);
      },
      goHome(){
          this.$router.push("/index");
      }
  },
}
</script>

<style lang="scss" scoped >
.model-content{
    padding: 0.5rem;
    height: 2.6rem;
    align-items: center;
    justify-content: space-between;
    font-size: 0.85rem;
    background-color: #dc6350;
    color: white;
    section{
        display: inline-flex;
        align-items: center;
        i{
            font-size: 1.3rem;
            margin-right:0.3rem; 
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/headerNav.vue